'use client'

import Link from 'next/link'

interface RowIdentityProps {
  id: string
  brandName: string
  fullName: string
  href: string
}

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

// Brand above, model name below (the brand prefix is dropped from the name so
// "Phonak" is not read twice; the accessible name keeps it).
export const RowIdentity = ({ id, brandName, fullName, href }: RowIdentityProps) => {
  const shortName = brandName ? fullName.replace(new RegExp(`^${escapeRegExp(brandName)}\\s+`, 'i'), '') : fullName
  const displayName = shortName || fullName

  return (
    <div className="col-start-2 row-start-1 min-w-0 self-start">
      {brandName ? (
        <p className="text-navy/60 text-[13px] leading-tight font-medium md:text-[14px]">{brandName}</p>
      ) : null}
      <h3 id={id} className="mt-0.5 text-[18px] leading-[1.2] font-semibold tracking-[-0.01em] md:text-[20px]">
        <Link
          href={href}
          prefetch={false}
          data-tracking="ignore"
          className="text-navy focus-visible:outline-lapis no-underline underline-offset-4 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          {displayName !== fullName ? <span className="sr-only">{brandName} </span> : null}
          {displayName}
        </Link>
      </h3>
    </div>
  )
}
